module.exports = "/static/assets/f83649a6f99757d24102449927a44929.png";